<template>
  <div id="productIntroduction" style="background-color: #F4F6F8;min-height: 905px">
    <div class="productBack">
      <div style="width: 1280px;text-align: left;display: inline-block">
        <div class="title">软件简介</div>
        <div class="subTitle">
          PKPM-CAE是一款完整自主可控的通用仿真软件，集成了仿真前后处理系统、任务调度系统、网格划分内核及通用有限元计算内核，致力于服务国内建筑、交通、能源、军工等工程/工业领域的广泛仿真需求。
        </div>
      </div>
    </div>
    <div class="main">
      <div class="content">
        <div style="width: 100%" v-if="imgList.length!==0" v-for="(item,index) in imgList">
          <div>
            <img :src="item.uri" alt="" style="width: 100%;height: 100%">
          </div>
        </div>
      </div>
    </div>

    <!--    <div class="content">-->

    <!--      <div class="categories">-->
    <!--        <div style="height: 100%">-->
    <!--          <div v-for="(item,index) in categoryList">-->
    <!--            <div @click="choseCate(1,item,index)" class="one" :class="[item.name===nowCate.name?'choseCate':'']">-->
    <!--              <img v-if="item.name!==nowCate.name" src="../assets/img/category.png" style="width: 16px;position: relative;top: -2px" alt="">-->
    <!--              <img v-else src="../assets/img/category-blue.png" style="width: 16px;position: relative;top: -2px" alt="">-->
    <!--              {{ item.name }}-->
    <!--              <img v-show="item.children.length!==0&&item.showChildren" src="../assets/img/down.png"-->
    <!--                   style="width: 15px;float: right;position: relative;top: 5px" alt="">-->
    <!--              <img v-show="item.children.length!==0&&!item.showChildren" src="../assets/img/up.png"-->
    <!--                   style="width: 15px;float: right;position: relative;top: 5px" alt="">-->
    <!--            </div>-->
    <!--            <div v-show="item.children.length!==0&&item.showChildren">-->
    <!--              <div v-for="i in item.children" @click="choseCate(2,i)" class="two"-->
    <!--                   :class="[i.name===nowCate.name?'choseCate':'']">{{ i.name }}-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->

    <!--      </div>-->

    <!--      <div style="display: inline-block; width: 985px;margin-left: 215px">-->
    <!--&lt;!&ndash;        <div v-for="(i,idx) in imgCates">&ndash;&gt;-->
    <!--          <div style="width: 100%" v-if="imgList.length!==0" v-for="(item,index) in imgList">-->
    <!--              <div>-->
    <!--                <img :src="item.uri" alt="" style="width: 100%;height: 100%">-->
    <!--              </div>-->

    <!--            </div>-->

    <!--&lt;!&ndash;        </div>&ndash;&gt;-->
    <!--      </div>-->


  </div>


</template>

<script>
import axios from 'axios'
import {getCmsList, listCategory, searchFiles, listRelationFiles} from '../api/index'
import utils from '../lib/utils'

export default {
  name: "productIntroduction",
  data() {
    return {
      // categoryList: [],
      // nowCate: '',
      // imgCates: [],

      imgList: [],


    }
  },


  methods: {

    // getCategoryList() {
    //   let data = {
    //     type: 'intro',
    //   }
    //   listCategory(data).then((res) => {
    //     if (!res.data.result.success) {
    //       this.$Message.error(res.data.result.info);
    //     } else {
    //       this.categoryList = res.data.result.categorys
    //       this.categoryList.forEach((item) => {
    //         item.showChildren = false
    //       })
    //       //临时处理
    //       const lastElement = this.categoryList[1].children.pop();
    //       this.categoryList[1].children.unshift(lastElement);
    //
    //       this.nowCate = this.categoryList[0]
    //       this.choseCate(1, this.nowCate)
    //     }
    //   }).catch((error) => {
    //     console.log(error);
    //   });
    // },
    //
    // choseCate(level, cat, num) {
    //   this.nowCate = cat
    //   if (cat.name === '软件简介') {
    //     this.imgCates = []
    //     this.imgList = []
    //     this.getVideo()
    //   } else {
    //     if (level === 1) {
    //       cat.showChildren = !cat.showChildren
    //       this.$set(this.categoryList, num, cat)
    //     } else if (level === 2) {
    //       listCategory({
    //         type: 'intro',
    //         pid: cat.id
    //       }).then((res) => {
    //         if (!res.data.result.success) {
    //           this.$Message.error(res.data.result.info);
    //         } else {
    //           this.imgCates = []
    //           this.imgList = []
    //           this.imgCates = res.data.result.categorys
    //           // console.log(this.imgCates)
    //           // this.getVideos()
    //           this.getVideo()
    //           console.log(this.imgList)
    //         }
    //       }).catch((error) => {
    //         console.log(error);
    //       });
    //     }
    //   }
    //
    // },
    //
    // getVideos() {
    //   this.imgList = []
    //   this.imgCates.forEach((item, index) => {
    //     searchFiles({
    //       type: 'intro',
    //       categoryId: item.id
    //     }).then((res) => {
    //       if (!res.data.result.success) {
    //         this.$Message.error(res.data.result.info);
    //       } else {
    //         this.$set(this.imgList, index, res.data.result.cmsFiles)
    //         if (this.imgList[index].length !== 0) {
    //           this.imgList[index].forEach((ids, ind) => {
    //             ids.uri = utils.handleHttps(ids.uri)
    //             ids.imgUri = utils.handleHttps(ids.imgUri)
    //             ids.prog = 0
    //           })
    //         }
    //         console.log(this.imgList)
    //       }
    //     }).catch((error) => {
    //       console.log(error);
    //     });
    //   })
    // },
    getContent() {
      searchFiles({
        type: 'intro',
        categoryId: 61
      }).then((res) => {
        if (!res.data.result.success) {
          this.$Message.error(res.data.result.info);
        } else {
          this.imgList = res.data.result.cmsFiles
          // this.$set(this.imgList, 0, res.data.result.cmsFiles)
          if (this.imgList.length !== 0) {
            this.imgList.forEach((item, index) => {
              item.uri = utils.handleHttps(item.uri)
              item.imgUri = utils.handleHttps(item.imgUri)
              item.prog = 0
              item.showProg = false
            })
          }
          console.log(this.imgList)
        }
      }).catch((error) => {
        console.log(error);
      });
    },


  },
  mounted() {
    // window.addEventListener('scroll', () => {
    //   const currentScroll = window.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop ||
    //     0;
    //
    //   if (currentScroll >= 300) {
    //     this.$store.commit('changePage', 1);
    //   }else{
    //     this.$store.commit('changePage', 0);
    //   }
    // });
    window.scrollTo(0, 0)
    this.getContent()
    // this.getCategoryList()
    // this.getVideoList()
    // this.getImgList()
  }
}
</script>

<style scoped lang="scss">
.productBack {
  width: 100%;
  height: 280px;
  background: url("../../static/img/productIntroduction/productBack.png");
  text-align: center;

  .title {
    font-weight: 600;
    font-size: 32px;
    color: #FFFFFF;
    margin-top: 118px;
  }

  .subTitle {
    width: 60%;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 8px;
  }
}

.main {
  text-align: center;
  padding-top: 32px;
  padding-bottom: 36px;

  .content {
    text-align: left;
    display: inline-block;
    width: 1280px;
  }
}


//.categories {
//  position: fixed;
//  display: inline-block;
//  width: 200px;
//  background-color: white;
//  border-radius: 2px;
//  padding: 25px;
//  margin-right: 15px;
//
//  .one {
//    margin-bottom: 25px;
//    font-size: 16px;
//    color: #333333;
//    font-weight: 800;
//    cursor: pointer;
//  }
//
//  .two {
//    margin-bottom: 25px;
//    font-size: 14px;
//    color: #666666;
//    font-weight: 500;
//    margin-left: 20px;
//    cursor: pointer;
//  }
//
//
//}
//
//.choseCate {
//  color: #1175EB !important;
//}
//
//.content {
//  display: flex;
//  width: 1200px;
//  margin: 0 auto;
//  min-height: 830px;
//  padding-bottom: 45px;
//  padding-top: 100px;
//
//  .block {
//    border-radius: 4px;
//    position: relative;
//    display: inline-block;
//    width: 300px;
//    border: 1px solid #EFEFEF;
//    margin: 0 10px 30px 15px;
//
//    &:hover {
//      box-shadow: 5px 5px 5px rgba(239, 239, 239, 1);
//      color: #1175EB;
//
//
//    }
//
//    .videoArea {
//      /*font-size: 20px;*/
//      /*line-height: 200px;*/
//      overflow-y: hidden;
//      height: 170px;
//      width: 300px;
//      cursor: pointer;
//    }
//
//    .textArea {
//      height: 50px;
//      background: #FFFFFF;
//      border-radius: 0 0 4px 4px;
//      padding: 15px;
//      width: 300px;
//
//      .cont {
//        display: inline-block;
//        width: 80%;
//        /*width: 100%;*/
//        white-space: nowrap;
//        overflow: hidden;
//        text-overflow: ellipsis;
//      }
//
//      .progClass {
//        bottom: 0;
//        left: 15px;
//        position: absolute;
//      }
//    }
//
//  }
//}
//
//@media (max-width: 1440px) {
//  .content {
//    width: 920px;
//  }
//  .categories {
//    left: 5px;
//  }
//}
</style>



// WEBPACK FOOTER //
// src/components/productIntroduction.vue